import { DestroyRef, inject, Injectable, signal, Signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

@Injectable()
export class DrawerService {
    private sidenav: MatSidenav;
    private readonly _isOpen = signal<boolean>(false);
    public readonly isOpen: Signal<boolean> = this._isOpen.asReadonly();
    private readonly destroyRef = inject(DestroyRef);
    private openedChangeSubscription?: Subscription;

    constructor() {}

    public setSidenav(sidenav: MatSidenav) {
        this.sidenav = sidenav;
        this._isOpen.set(sidenav.opened);
        this.openedChangeSubscription?.unsubscribe();
        this.openedChangeSubscription = sidenav.openedChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((isOpen) => this._isOpen.set(isOpen));
    }

    public open() {
        return this.sidenav.open();
    }

    public close() {
        return this.sidenav.close();
    }

    public toggle() {
        return this.sidenav.toggle();
    }
}
